<template>
    <div :class="props.type === 'vas' ? 'board_wrap' : ''" v-bind:class="[props.customClass]" id="servey_list">
        <div v-if="props.isShowTotal" class="total_length">
            {{ $t("notice.total") }} : {{ totalLength }} {{ $t("notice.count") }}
        </div>
        <div class="gallery_board" v-if="props.type !== 'vas'">
            <ul v-if="list.length > 0">
                <li v-for="(row, idx) in list" :key="idx">
                    <div v-for="(col, colIdx) in columns" v-on:click="col.clickable === true ? onRowClick(row) : ''"
                        v-html="fnRender(row, col)" :class="[col.clickable === true ? 'areaClick' : '', col.class]">
                    </div>
                </li>
            </ul>

            <div v-if="list.length === 0" class="no_list">
                <p>게시글이 없습니다.</p>
            </div>
        </div>
        <table class="survey_list" v-if="state.type === 'vas'">
            <thead v-if="props.isShowTitle">
                <tr>
                    <th v-for="(col, idx) in columns" :key="idx" :class="[col.class]">
                        {{ col.label }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(row, idx) in list" :key="idx">
                    <td v-for="(col, colIdx) in columns" :key="colIdx" v-html="fnRender(row, col)"
                        v-on:click="col.clickable === true ? onRowClick(row) : ''"
                        :class="[col.clickable === true ? 'areaClick' : '', col.class]"></td>
                </tr>
            </tbody>
        </table>
        <div v-if="props.isShowPageBtn" class="paging_wrap">
            <div class="dataTables_paginate paging_full_numbers" id="list_paginate">
                <ul class="pagination">
                    <li class="paginate_button page-item first disabled" id="list_first" @click="fnPaging(1)">
                        <router-link to="#" aria-controls="list" data-dt-idx="0" tabindex="0" class="page-link">
                            <img src="@/assets/common/pg_first_ico.png" alt="" />
                        </router-link>
                    </li>
                    <li class="paginate_button page-item previous disabled" id="list_previous"
                        @click="currentPage > 1 ? fnPaging(currentPage - 1) : ''">
                        <router-link to="#" aria-controls="list" data-dt-idx="1" tabindex="0" class="page-link">
                            <img src="@/assets/common/pg_prev_ico.png" alt="" />
                        </router-link>
                    </li>
                    <template v-if="currentPage <= 3">
                        <li v-for="index in Math.min(paging, 5)" :key="index" @click="fnPaging(index)"
                            class="paginate_button page-item" :class="[index === currentPage ? 'active' : '']">
                            {{ index }}
                        </li>
                    </template>
                    <template v-else-if="currentPage >= paging - 2">
                        <li v-for="index in [paging - 4, paging - 3, paging - 2, paging - 1, paging]" :key="index"
                            @click="fnPaging(index)" class="paginate_button page-item"
                            :class="[index === currentPage ? 'active' : '']">
                            {{ index }}
                        </li>
                    </template>
                    <template v-else>
                        <li v-for="offset in [-2, -1, 0, 1, 2]" :key="currentPage + offset"
                            @click="fnPaging(currentPage + offset)" class="paginate_button page-item"
                            :class="[currentPage + offset === currentPage ? 'active' : '']">
                            {{ currentPage + offset }}
                        </li>
                    </template>
                    <li class="paginate_button page-item next" id="list_next"
                        @click="currentPage < paging ? fnPaging(currentPage + 1) : ''">
                        <router-link to="#" aria-controls="list" data-dt-idx="4" tabindex="0" class="page-link">
                            <img src="@/assets/common/pg_next_ico.png" alt="" />
                        </router-link>
                    </li>
                    <li class="paginate_button page-item last" id="list_last" @click="fnPaging(paging)">
                        <router-link to="#" aria-controls="list" data-dt-idx="5" tabindex="0" class="page-link">
                            <img src="@/assets/common/pg_end_ico.png" alt="" />
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>
    </div>

</template>

<script lang="ts" config>
import { reactive, computed } from "@/BaseComponent";
export default {
    props: ["type", "list", "columns", "currentPage", "totalLength", "perPage", "isShowTitle", "isShowTotal", "isShowPageBtn", "customClass"],
    emits: ["onPaging", "onRowClick", "fnGoPage"],

    setup(props: any, emits: any) {
        const state = reactive({
            type: props.type || "" as string,
            list: [] as any,
            columns: {} as any,
            currentPage: 1 as number,
            totalLength: 1 as number,
            perPage: 1 as number,
        });

        const paging = computed(() => {
            if (Math.ceil(props.totalLength / props.perPage) === 0) {
                return 1;
            }
            return Math.ceil(props.totalLength / props.perPage);
        });
        const fnPaging = (index: number) => {
            emits.emit("onPaging", index);
        };

        const onRowClick = (row: any) => {
            emits.emit("onRowClick", row.idx);
        };
        const fnRender = (row: any, col: any) => {
            let html = "";
            if (col.render) {
                if (props.type !== 'vas') {
                    const temp = row;
                    html += `<div class="thumb"><img src="${temp["thumbnail"]}" alt="image"></div>`;
                    html += `<div class="title">${temp["title"]}</div>`;
                    return html;
                } else {
                    return col.render(row);
                }
            } else {
                if (col.key === "image") {
                    return `<div class="thumb"><img src="${row.fileLocation}" alt="image"></div>`;
                } else {
                    return `${row[col.key]}`;
                }
            }
        };

        return {
            props,
            state,
            paging,
            fnPaging,
            onRowClick,
            fnRender,
        };
    },
};
</script>
